import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import OrderStatusBadge from '../../Shared/OrderStatusBadge';
import { formatAmount, formatDateTime } from 'src/Common/utils';

const Menu = ({ id }) => (
    <div className="dropdown">
        <a className="btn btn-sm btn-icon-only text-light"
            href="javascript:void(0)" /* eslint-disable-line no-script-url */
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
        >
            <i className="fas fa-ellipsis-v" />
        </a>
        <div className="dropdown-menu dropdown-menu-right dropdown-menu-arrow">
            <Link className="dropdown-item" to={`/repasse/${id}`}>Detalhes</Link>
            {/* <a className="dropdown-item" href="#">Cancelar</a> */}
        </div>
    </div>
);

const NotAvailableAmount = () => (
    <small>Não Disponível</small>
);


export default class TableRow extends Component {
    transferBadge (transfer){
      if(transfer){
        if (transfer.status == "TRANSFER_SUCCESSFUL"){
          return <span className="badge badge-success">Concluído</span>
        }
        if (transfer.status == "TRANSFER_PENDING"){
          return <span className="badge badge-info">Em processamento</span>
        }
        if (transfer.status == "TRANSFER_FAILED"){
          return <span className="badge badge-warning">Falhou</span>
        }
      }
      return <span className="badge badge-warning">Falhou</span>
    }

    render() {
        const { id, amount, entity, portalOrder, createdAt, transfer} = this.props;

        let name = ""

        if (entity.portalUser) {
          name = "Vendedor - " + entity.portalUser["user"]["name"]
        }else if (entity.establishment) {
          name = "Estabelecimento - " + entity.establishment["title"]
        }else if (entity.operator){
          name = "Operador - " + entity.operator["title"]
        }

        return (
            <tr>
              <td className="text-right">
                  <Menu id={id} />
              </td>
              <td>{name}</td>
              <td>{formatAmount(amount)}</td>
              <td>{this.transferBadge(transfer)}</td>
              <td>{formatDateTime(createdAt)}</td>
            </tr>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Pages/CommissionsTransfers/TableRow.js